"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentsRoot = void 0;
var tslib_1 = require("tslib");
var ui_card_1 = require("@hopin-team/ui-card");
var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Sizes;
(function (Sizes) {
    Sizes["small"] = "width: 32rem;";
    Sizes["medium"] = "width: 40rem;";
    Sizes["large"] = "width: 50rem;";
})(Sizes || (Sizes = {}));
var DialogSizes;
(function (DialogSizes) {
    DialogSizes["small"] = "width: 20rem;";
    DialogSizes["medium"] = "width: 30rem;";
})(DialogSizes || (DialogSizes = {}));
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["small"] = 362] = "small";
    Breakpoints[Breakpoints["medium"] = 432] = "medium";
    Breakpoints[Breakpoints["large"] = 600] = "large";
})(Breakpoints || (Breakpoints = {}));
/**
 * The Modal will go into full screen mode when the viewport reaches the 16px
 * padding around the ContentsRoot boundaries.
 * @param size
 * @returns Media query for the size plus 16px padding.
 */
var makeMobileStyles = function (size) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  @media (max-width: ", "px) {\n    width: 100%;\n\n    ", " {\n      border-radius: 0;\n      height: 100%;\n      height: 100vh;\n    }\n  }\n"], ["\n  @media (max-width: ", "px) {\n    width: 100%;\n\n    ", " {\n      border-radius: 0;\n      height: 100%;\n      height: 100vh;\n    }\n  }\n"])), Breakpoints[size] + 32, ui_card_1.Card); };
exports.ContentsRoot = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  max-height: 100vh;\n\n  ", " {\n    max-height: 100vh;\n  }\n\n  ", "\n  ", "\n  ", "\n"], ["\n  position: relative;\n  max-height: 100vh;\n\n  ", " {\n    max-height: 100vh;\n  }\n\n  ", "\n  ", "\n  ", "\n"])), ui_card_1.Card, function (props) { return !props.isDialog && (0, ui_helper_props_to_styles_1.mapStyles)(props, 'size', Sizes); }, function (props) { return props.isDialog && (0, ui_helper_props_to_styles_1.mapStyles)(props, 'size', DialogSizes); }, function (_a) {
    var size = _a.size;
    return makeMobileStyles(size);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=contents.js.map